"use client";

import React from "react";
import { MessageCircle, Timer, Zap, Mail } from "lucide-react";
import Link from "next/link";

export default function TopContactBar() {
  return (
    <div className="bg-gradient-to-r from-indigo-700 via-purple-700 to-indigo-800 text-white py-2 px-4 z-[60] shadow-md border-b border-white/10">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 md:gap-4">
        {/* Left Side: Live Indicator & Message */}
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5 px-2 py-0.5 bg-white/10 rounded-full border border-white/20 backdrop-blur-sm">
            <span className="flex h-2 w-2 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            <span className="text-[10px] md:text-xs font-bold uppercase tracking-wider text-green-300">
              Canlı Destek
            </span>
          </div>
          <div className="flex items-center gap-2 text-xs md:text-sm">
            <Zap className="w-4 h-4 text-yellow-400 animate-pulse" />
            <span className="text-indigo-50 font-medium">
              Sorularınız{" "}
              <span className="text-white font-bold underline decoration-yellow-400 decoration-2 underline-offset-4">
                60 Dakika
              </span>{" "}
              İçinde Cevaplanır!
            </span>
          </div>
        </div>

        {/* Right Side: Action Links */}
        <div className="flex items-center gap-2 md:gap-4">
          <div className="hidden xl:flex items-center gap-2 text-xs text-indigo-100 mr-2">
            <Timer className="w-3.5 h-3.5" />
            <span>Ortalama Yanıt Süresi: 24dk</span>
          </div>

          <div className="flex items-center gap-2">
            {/* WhatsApp Link */}
            <a
              href="https://wa.me/19129224004?text=Merhaba,%20IKAI%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.%20Demo,%20fiyatland%C4%B1rma%20ve%20%C5%9Firketimize%20uygun%20kullan%C4%B1m%20senaryosu%20i%C3%A7in%20yard%C4%B1mc%C4%B1%20olur%20musunuz%3F"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-3 md:px-4 py-1.5 rounded-full text-xs font-bold transition-all transform hover:scale-105 active:scale-95 shadow-lg group"
            >
              <MessageCircle className="w-3.5 h-3.5 group-hover:rotate-12 transition-transform" />
              <span className="hidden sm:inline">WhatsApp'tan Yazın</span>
              <span className="sm:hidden">WhatsApp</span>
            </a>

            {/* Contact Form Link */}
            <Link
              href="/iletisim"
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-3 md:px-4 py-1.5 rounded-full text-xs font-bold border border-white/20 backdrop-blur-sm transition-all transform hover:scale-105 active:scale-95"
            >
              <Mail className="w-3.5 h-3.5 text-indigo-200" />
              <span className="hidden sm:inline">İletişim Formu</span>
              <span className="sm:hidden">Form</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
